<template>
  <div>
    <a-spin style="z-index: 99999;" :spinning="submitting">


      <jet-dialog-modal maxWidth="2xl" :show="createRetroModal === true" @close="createRetroModal = false">


        <template #content>

          <create-retro-form :is-public="true" :click-text="'Create Your Board'"
                             @created="boardCreated"></create-retro-form>
        </template>

        <template #footer>
          <div class="text-md text-blue-500 font-bold inline-block ml-1">
            agilesuite.io
          </div>
        </template>
      </jet-dialog-modal>
      <div class="py-4">

        <div>
          <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-2" role="alert">
            <p class="text-yellow-700 font-bold">Tips:</p>
            <p class="text-gray-400 font-bold text-lg">Create a public board that any one has link can access it.</p>
          </div>


          <div>
            <button @click="createRetroModal = true;" type="button"
                    class="relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">

            <span class="mt-2 block text-lg font-bold font-medium text-gray-900">
          + Create a public board
        </span>
            </button>
          </div>

          <div  v-if="cards.length>0" >

            <!-- This example requires Tailwind CSS v2.0+ -->
            <div
                class="text-sm font-semibold  py-2 font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-red-400 to-yellow-400">
              * The
              colors
              on card background indicate how many items were created for each column.
            </div>
            <div class="bg-white shadow hover:shadow-lg overflow-hidden sm: mb-4" v-for="item in cards"
                 :key="item.id">
              <div class="divide-y divide-gray-200">

                <div :style="getColorBackgroundString(item.colors)">
                  <div>
                    <div class="px-4 py-4 flex hover:shadow-lg items-center sm:px-6">
                      <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                        <div class="truncate">
                          <div class="flex text-sm">
                            <p class="font-bold text-xl text-black  truncate">{{ item.name }}</p>
                            <div class="inline-block space-x-2 ml-1">
    <span v-if="item.rate"
          class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
    {{ item.rate }}
  </span>
                              <span v-if="item.status==='Finished'"
                                    class="ml-2 flex-shrink-0 inline-block px-2 py-1 text-green-800 text-xs font-bold bg-green-100 rounded-full">
                      Finished
                    </span>

                              <span v-if="item.status==='New'"
                                    class="ml-2 flex-shrink-0 inline-block px-2 py-1 text-blue-800 text-md font-bold bg-blue-100 rounded-full">
                      New
                    </span>

                              <span v-if="item.status==='In Progress'"
                                    class="ml-2 flex-shrink-0 inline-block px-2 py-1 text-orange-800 text-xs font-bold bg-orange-100 rounded-full">
                      In Progress
                    </span>
                            </div>
                          </div>
                          <players :players="item.players"></players>
                          <div class="mt-2 flex">
                            <div class="flex items-center text-sm text-gray-500">
                              <!-- Heroicon name: solid/calendar -->
                              <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                   xmlns="http://www.w3.org/2000/svg"
                                   viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd"
                                      d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                      clip-rule="evenodd"/>
                              </svg>
                              <p>
                                Created on
                                <time datetime="2020-01-07">{{ item.date }}</time>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="mt-4 flex-shrink-0 sm:mt-0 sm:ml-5">
                          <div class="flex ">

                            <button type="button" v-if="item.is_finished" @click="this.$inertia.visit(
                                          route('retrospective.room.summary', {
                                      room_key: item.key,
                                      }));"
                                    class="focus:outline-none mr-2 rounded-full bg-white hover:bg-yellow-100 text-yellow-500 border-2  mt-2 py-1 px-2  border-yellow-500 font-bold rounded"

                            >
                              Summary
                            </button>
                            <button type="button" @click="this.$inertia.visit(
                                          route('retrospective.accessRoom', {
                                      id: item.key,
                                      }));"
                                    class="focus:outline-none rounded-full bg-white hover:bg-blue-100 text-blue-500 border-2  mt-2 py-1 px-2  border-blue-500 font-bold rounded"

                            >
                              Enter in
                            </button>
                            <button type="button" @click="clone(item.id)"
                                    class="focus:outline-none rounded-full bg-white hover:bg-gray-400 text-black border-2 ml-2 mt-2 py-1 px-2  border-black font-bold rounded"

                            >
                              Clone
                            </button>

                            <a-tooltip color="blue">
                              <template #title>Share this link to your team members.
                              </template>

                              <button type="button" @click="info(item.key)"
                                      class="focus:outline-none rounded-full bg-white hover:bg-purple-100 text-purple-500 border-2  mt-2 py-1 px-2 ml-2 border-purple-500 font-bold rounded">
                                URL
                              </button>
                            </a-tooltip>


                            <button v-if="$page.props.user.id === item.created_by" type="button"
                                    @click="handleDelete(item.id)"
                                    class="focus:outline-none rounded-full bg-white hover:bg-red-100 text-red-500 border-2  mt-2 py-1 px-2 ml-2 border-red-500 font-bold rounded">
                              Delete
                            </button>
                            <button v-if="$page.props.user.id === item.created_by" type="button"
                                    @click="openSetting(item)"
                                    class="focus:outline-none rounded-full bg-white hover:bg-gray-100 text-black border-2  mt-2 py-1 px-2 ml-2 border-black font-bold rounded">
                              Edit
                            </button>
                            <input
                                type="hidden"
                                :id="'board' + item.key"
                                :value="getLink(item.key)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-5" v-else>
            <no-data></no-data>
          </div>
          <a-drawer
              width="400"

              placement="right"
              :closable="false"
              v-model:visible="visible"
          >

            <template #title>
              <label class="font-bold text-2xl">Settings</label>
            </template>
            <retro-setting-drawer @updated="fetchBoards" v-model:room="selectedRoom"></retro-setting-drawer>
          </a-drawer>
        </div>


      </div>
    </a-spin>
  </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Button from "@/Jetstream/Button";
import {message} from "ant-design-vue";
import {
  ref,
  onMounted,
} from "vue";
import JetDialogModal from "@/Jetstream/DialogModal";
import CreateRetroForm from "@/Pages/Retrospective/CreateRetroForm";
import ActionBoard from "@/Pages/Retrospective/ActionBoard/ActionBoard";
import CustomRetroFlow from "@/Pages/Retrospective/CustomRetroFlow";
import RetroSettingDrawer from "@/Pages/Retrospective/Components/RetroSettingDrawer";
import NoData from "@/Components/NoData/NoData";
import Players from "@/Pages/Retrospective/Components/Players";
export default {
  props: [],
  data() {
    return {
      testStyle: '  background: -webkit-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -webkit-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: -o-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -o-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: -moz-linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), -moz-linear-gradient(110deg, #dd0000 66%, #ffc608 66%);\n' +
          '  background: linear-gradient(90deg, #000 33%, rgba(0, 0, 0, 0) 33%), linear-gradient(110deg, #dd0000 66%, #ffc608 66%);'

    };
  },
  mounted() {
  },
  created() {
  },
  setup() {

    const cards = ref([]);
    const submitting = ref(false);
    const createRetroModal = ref(false);
    const fetchBoards = () => {
      submitting.value = true;
      axios
          .get(route("retrospective.all.public.boards"))
          .then((response) => {
            submitting.value = false;
            cards.value = response.data.data;
          })
          .catch((error) => {
            submitting.value = false;
            console.log(error);
            message.error('Our system cannot fetch your boards data. Please contact us.', 5);
          });
    }
    const visible = ref(false);
    const selectedRoom = ref({
      id: null,
      key: null,
      survey_question: null,
      room_name: null
    });
    const openSetting = (room) => {
      visible.value = true;
      selectedRoom.value = {
        id: room.id,
        key: room.key,
        survey_question: room.survey_question,
        room_name: room.name
      };
    }

    const boardCreated = () => {
      createRetroModal.value = false;
      fetchBoards();
    }
    const clone = (boardId) => {
      submitting.value = true;
      axios
          .post(route("retrospective.clone"), {
            room_id: boardId
          })
          .then((response) => {

            if (response.data.success) {
              fetchBoards();
              message.success('Successfully cloned.', 5);
            } else {
              submitting.value = false;
              message.error(response.data.message, 5);
            }
          })
          .catch((error) => {
            submitting.value = false;
            console.log(error);
            message.error('We cannot clone your room.', 5);
          });
    }

    onMounted(() => {
      fetchBoards();
    });

    const handleDelete = (itemKey) => {
      if (confirm('Are you sure you want to delete it?')) {
        axios
            .delete(route("retrospective.room.delete", {
              room_id: itemKey
            }))
            .then((response) => {
              fetchBoards();
              message.success('Successfully deleted.', 5);
            })
            .catch((error) => {
              submitting.value = false;
              console.log(error);
              message.error('We cannot delete your retro.', 5);
            });
      }
    }


    return {
      fetchBoards,
      selectedRoom,
      visible,
      openSetting,
      boardCreated,
      createRetroModal,
      submitting,
      cards,
      clone,
      handleDelete
    }
  },

  methods: {
    getColorBackgroundString(color) {
      return 'background: linear-gradient(to right, ' + color.join(',') + ');';
    },
    info(roomKey) {
      let testingCodeToCopy = document.querySelector("#board" + roomKey);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
        message.success("Your link is copied");
      } catch (err) {
        message.error("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    getLink(id) {
      return this.$page.props.env !== 'production' ? 'https://staging.agilesuite.io/boards/' + id : 'https://agilesuite.io/boards/' + id;
    },
  },
  components: {
    Players,
    NoData,
    RetroSettingDrawer,
    CustomRetroFlow,
    ActionBoard,
    CreateRetroForm,
    JetDialogModal,
    Button,
    AppLayout,
  },
};
</script>
